import { useState, useEffect } from 'react'
import DashboardLayout from '../../common/DashboardLayout'
import { Icon1, Icon2, User4, course04 } from '../../imagepath'
import { Link } from 'react-router-dom'
import PaymentServices from "../../../services/PaymentServices";
const SchoolOrderHistory = () => {
    const [apiResponse, setApiResponse] = useState(null);
    useEffect(() => {
        const fetchPayments = async () => {
          try {
            const response = await PaymentServices.getPaymentHistory();
            console.log("API Response:", response);
            
            if (response && response.payments) {
              setApiResponse(response);
            }
          } catch (error) {
            console.error("Error fetching videos:", error);
          }
        };
    
        fetchPayments();
      }, []);
    const userobj = JSON.parse(localStorage.getItem('user') || '{}');
    
    return (
        <DashboardLayout 
            role={1} 
            userType={userobj?.type}
            activeMenu="Order History"
            layoutType="topnav"
        >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4>Payment History</h4>
                                    <Link to="/payment" className="btn btn-primary">
                                        <i className="bx bx-credit-card me-1"></i>
                                        Make Payment
                                    </Link>
                                </div>
                                {/* Dashboard Grid */}
                                <div className="table-responsive custom-table">
                              <table id="orderHistoryTable" className="table table-nowrap mb-0">
                                            <thead>
                                            <tr>
                                                <th></th>
                                                {/* <th>School Name</th> */}
                                                <th>Payment</th>
                                                <th>Payment Method</th>
                                                <th>Payment Date</th>
                                                <th>Renewal Date</th>
                                                <th />
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(apiResponse) ? apiResponse.payments.map((payment,index) => (
                                            <tr key={payment._id}>
                                                <td>{index + 1}</td>
                                                {/* <td>
                                                <span className="title-course">
                                                  {school.name}
                                                </span>
                                                </td> */}
                                              <td>
                                                {payment ? (
                                                  payment.isPaid === false ? (
                                                    <span className="text-danger">
                                                      Unpaid - ${payment.amountDue || payment.displayAmount || 0}
                                                    </span>
                                                  ) : (
                                                    <span className="text-success">
                                                      Paid - ${payment.amountPaid?.toFixed(2) || 0}
                                                    </span>
                                                  )
                                                ) : "N/A"}
                                              </td> 
                                                <td>
                                                  {payment?.isPaid === true ? (payment.method || "N/A") : "N/A"}
                                                </td>
                                                <td>
                                                  {payment?.startDate
                                                    ? new Date(payment.startDate).toLocaleString()
                                                    : payment?.isPaid === false ? "Due" : "N/A"}
                                                </td>
                                                <td>
                                                  {(payment?.renewalDate || payment?.endDate) ? (() => {
                                                    const renewalDate = new Date(payment.renewalDate || payment.endDate);
                                                    const today = new Date();
                                                    const daysUntilRenewal = Math.ceil((renewalDate - today) / (1000 * 60 * 60 * 24));
                                                    const isExpired = daysUntilRenewal < 0;
                                                    const isExpiringSoon = daysUntilRenewal <= 30 && daysUntilRenewal >= 0;
                                                    
                                                    return (
                                                      <div>
                                                        {renewalDate.toLocaleDateString()}
                                                        {isExpired && (
                                                          <span className="badge bg-danger small ms-1">Expired</span>
                                                        )}
                                                        {isExpiringSoon && !isExpired && (
                                                          <span className="badge bg-warning small ms-1">{daysUntilRenewal} days</span>
                                                        )}
                                                      </div>
                                                    );
                                                  })() : "N/A"}
                                                </td>
                                                <td>
                                               
                                                </td>
                                            </tr>
                                            )) : ''}
                                            </tbody>
                                        </table>
                                </div>
                            {/* <div className="dash-pagination">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <p>Page 1 of 2</p>
                    </div>
                    <div className="col-6">
                      <ul className="pagination">
                        <li className="active">
                          <Link to="#">1</Link>
                        </li>
                        <li>
                          <Link to="#">2</Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="bx bx-chevron-right" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
        </DashboardLayout>
    )
}

export default SchoolOrderHistory
